const Footer = () => {
  return (
    <div className="container-fluid footer py-3">
      <div className="row justify-content-center">
        <div className="col-lg-auto col-mg-auto">
          <p style={{ marginBottom: "0px" }}>
            ©The Sparks Foundation | Made with ❤️ by
            <span>
              <a
                className="mx-1"
                style={{ color: "rgb(0, 191, 255)", textDecoration: "none" }}
                href="https://github.com/khushigit13">
                Khushi Sahu👩‍💻
              </a>
            </span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Footer;
